



















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding } from '@/queries/__generated__/ameldingNewData';
import { paycheckReadyForAmelding } from '@/app/Paycheck';

@Component({})
export default class AmeldingFormPaycheck extends Vue {
  @Prop({ type: Object, required: true }) private paycheck!: GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding;

  private paycheckSelected(event: { target: HTMLInputElement }): void {
    if (this.isLocked && !this.paycheck.isSentToAltinn) event.target.checked ? this.$emit('paycheck-selected') : this.$emit('paycheck-unselected');
  }

  private get isLocked(): boolean {
    return !!this.paycheck.lockedAt;
  }

  private paycheckReadyForAmelding = paycheckReadyForAmelding;
}
